import { useCallback } from "react";
// eslint-disable-next-line no-restricted-imports
import {
  type NavigateOptions,
  type To,
  useNavigate as useReactRouterNavigate,
} from "react-router-dom";

import { useAppDispatch } from "store";
import { viewStateActions } from "store/slices/view";

// This hook is used to navigate to a new page and update the query params in the view state.
export const useNavigate = () => {
  const navigate = useReactRouterNavigate();
  const dispatch = useAppDispatch();

  const enhancedNavigate = useCallback(
    (to: To, options?: NavigateOptions) => {
      let newQueryString = "";

      if (typeof to === "string") {
        newQueryString = new URLSearchParams(to.split("?")[1]).toString();
      } else if (to && typeof to === "object" && "search" in to) {
        newQueryString = new URLSearchParams(to.search).toString();
      }

      dispatch(viewStateActions.updateQueryParams(newQueryString));

      navigate(to, options);
    },
    [navigate, dispatch],
  );

  return enhancedNavigate;
};
